// --- React
import React from 'react';
// --- UI Components
import { Col, Row } from 'antd';
import Typography from '@dtci/spellbook/Typography';
// --- Utils
import { getSpartaDetails } from '../utils/getDetailsData';
// --- Styles
import '../../styles.scss';

/**
 * SpartaCard Component
 *
 * This component is responsible for rendering a card that displays detailed
 * information about a product's Sparta data.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.details - The details of the product to be displayed.
 * @returns {JSX.Element} Sparta card with detailed information.
 */
export function SpartaCard({ details }) {
    // Function to extract Sparta details from the provided data
    const spartaDetails = getSpartaDetails(details);

    return (
        <Row style={{ marginTop: 20 }}>
            <Col>
                {spartaDetails.map(({ label, value }, index) => (
                    <Row key={index}>
                        <Typography variant="T20">
                            <b>{label}:</b>
                            <br />
                            {value}
                        </Typography>
                    </Row>
                ))}
            </Col>
        </Row>
    );
}
